// extracted by mini-css-extract-plugin
export var actionButton = "_jg-0";
export var fileInput = "_jg-2";
export var paperclip = "_jg-1";